var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20002 7.20002V6.00002C7.20002 4.0118 8.8118 2.40002 10.8 2.40002H13.2C15.1882 2.40002 16.8 4.0118 16.8 6.00002V7.20002H19.2C20.5255 7.20002 21.6 8.27454 21.6 9.60002V13.8849C18.6116 14.9937 15.3779 15.6 12.0001 15.6C8.6222 15.6 5.38846 14.9937 2.40002 13.8849V9.60002C2.40002 8.27454 3.47454 7.20002 4.80002 7.20002H7.20002ZM9.60002 6.00002C9.60002 5.33728 10.1373 4.80002 10.8 4.80002H13.2C13.8628 4.80002 14.4 5.33728 14.4 6.00002V7.20002H9.60002V6.00002ZM10.8 12C10.8 11.3373 11.3373 10.8 12 10.8H12.012C12.6748 10.8 13.212 11.3373 13.212 12C13.212 12.6628 12.6748 13.2 12.012 13.2H12C11.3373 13.2 10.8 12.6628 10.8 12Z",
    fill: "#4FC0CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40002 16.4307V19.2C2.40002 20.5255 3.47454 21.6 4.80002 21.6H19.2C20.5255 21.6 21.6 20.5255 21.6 19.2V16.4308C18.5847 17.4486 15.3557 18 12.0001 18C8.64438 18 5.41538 17.4486 2.40002 16.4307Z",
    fill: "#4FC0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.9aaa61a5996a3457216b074859016508.svg";
export { ForwardRef as ReactComponent };